module.exports = __webpack_public_path__ + "static/media/underwater_childrens_museum_mural_rendering_2005.e66d7cbf.webp";